
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import ServicesPage from "@/pages/services/ServicesPage";

export function ServiceRoutes() {
  return (
    <Route 
      path="/services" 
      element={
        <ProtectedRoute>
          <ServicesPage />
        </ProtectedRoute>
      } 
    />
  );
}
